var map = {
	"./666.png": "672a",
	"./Emm.png": "8a49",
	"./OK.png": "f6df",
	"./亲亲.png": "629a",
	"./便便.png": "cb7b",
	"./偷笑.png": "b16d",
	"./傲慢.png": "46cf",
	"./再见.png": "d03b",
	"./凋谢.png": "ea0d",
	"./加油.png": "62b9",
	"./勾引.png": "b941",
	"./发呆.png": "9a88",
	"./发怒.png": "0ced",
	"./发抖.png": "a8b3",
	"./可怜.png": "3f04",
	"./右哼哼.png": "2810",
	"./叹气.png": "1397",
	"./吃瓜.png": "3b54",
	"./合十.png": "f0c7",
	"./吐.png": "cceb",
	"./呲牙.png": "9622",
	"./咒骂.png": "04eb",
	"./咖啡.png": "2b9f",
	"./哇.png": "82b8",
	"./啤酒.png": "0894",
	"./嘘.png": "f403",
	"./嘴唇.png": "2eb2",
	"./嘿哈.png": "6782",
	"./囧.png": "f580",
	"./困.png": "be2b",
	"./坏笑.png": "e392",
	"./大哭.png": "74180",
	"./天啊.png": "4ade",
	"./太阳.png": "6dfa",
	"./失望.png": "546c",
	"./奸笑.png": "b13b",
	"./好的.png": "cfce",
	"./委屈.png": "4a2a",
	"./害羞.png": "c7a3",
	"./尴尬.png": "1fdb",
	"./庆祝.png": "90da",
	"./弱.png": "f8c3",
	"./强.png": "3a5d",
	"./微笑.png": "b223",
	"./心碎.png": "f59d",
	"./快哭了.png": "1cd2",
	"./恐惧.png": "1023",
	"./悠闲.png": "0615",
	"./惊恐.png": "6020",
	"./惊讶.png": "0f28",
	"./愉快.png": "c76d",
	"./憨笑.png": "056b",
	"./打脸.png": "52ce",
	"./抓狂.png": "009a",
	"./抠鼻.png": "beac",
	"./抱拳.png": "35cd",
	"./拥抱.png": "b513",
	"./拳头.png": "c176",
	"./捂脸.png": "8c82",
	"./握手.png": "7fc2",
	"./撇嘴.png": "4758",
	"./擦汗.png": "7485",
	"./敲打.png": "74b1",
	"./无语.png": "55e2",
	"./旺柴.png": "397c",
	"./晕.png": "0b0e",
	"./晚安.png": "bfb9",
	"./机智.png": "2f98",
	"./汗.png": "7abd",
	"./流泪.png": "4863",
	"./炸弹.png": "5e9e",
	"./烟花.png": "ae48",
	"./爆竹.png": "f277",
	"./爱心.png": "2849",
	"./猪头.png": "58a7",
	"./生病.png": "5bef",
	"./疑问.png": "9baf",
	"./發.png": "e514",
	"./白眼.png": "8d64",
	"./皱眉.png": "7aae",
	"./睡.png": "7b4d",
	"./破涕为笑.png": "4d97",
	"./礼物.png": "1692",
	"./社会.png": "1781",
	"./福.png": "0c73",
	"./笑脸.png": "9584",
	"./红包.png": "700a",
	"./翻白眼.png": "d8c6",
	"./胜利.png": "6ff8",
	"./脸红.png": "b101",
	"./色.png": "c49c",
	"./苦涩.png": "4fda",
	"./菜刀.png": "2542",
	"./蛋糕.png": "578e",
	"./衰.png": "cd7a",
	"./裂开.png": "a818",
	"./让我看看.png": "4654",
	"./调皮.png": "e217",
	"./跳跳.png": "a8c3",
	"./转圈.png": "a656",
	"./鄙视.png": "c848",
	"./闭嘴.png": "02c3",
	"./阴险.png": "68f5",
	"./难过.png": "bec8",
	"./骷髅.png": "b39e",
	"./鲜花.png": "5ee5",
	"./鼓掌.png": "0c71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b60";